import { ComponentType } from '@angular/cdk/portal';
import { Component, InjectionToken, AfterViewInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { LegalLayoutComponent } from '../legal-layout.component';
import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// This is for resolve CircularDependency, coz Terms and Privacy are calling between them
export const TERMS_COMPONENT: InjectionToken<ComponentType<Component>> = new InjectionToken<ComponentType<Component>>(
  'TERMS_COMPONENT'
);

@TakeUntilDestroy
@Component({
  selector: 'slotcom-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  standalone: true,
  imports: [LegalLayoutComponent, UpperCasePipe, TranslateModule],
})
export class PrivacyComponent implements AfterViewInit {
  private termsComponent = inject<ComponentType<Component>>(TERMS_COMPONENT);
  private eventManager = inject(EventManager);
  private dialog = inject(MatDialog);

  protected readonly NonPersistedModalName = NonPersistedModalName;

  ngAfterViewInit(): void {
    const openCookiesElements = document.querySelectorAll('.openCookies');
    const openTermsElements = document.querySelectorAll('.openTerms');

    openCookiesElements.forEach((el) =>
      el.addEventListener('click', () => {
        this.openCookies();
      })
    );

    openTermsElements.forEach((el) =>
      el.addEventListener('click', () => {
        this.openTerms();
      })
    );
  }

  openCookies(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.PrivacyComponent, ModalType.View));

    this.dialog
      .getDialogById(NonPersistedModalName.PrivacyComponent)
      .afterClosed()
      .subscribe(() => {
        this.eventManager.openModal(new Modal(NonPersistedModalName.CookiesComponent, ModalType.View));
      });
  }

  openTerms(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.PrivacyComponent, ModalType.View));

    this.dialog
      .getDialogById(NonPersistedModalName.PrivacyComponent)
      .afterClosed()
      .subscribe(() => {
        this.eventManager.openModal(new Modal(NonPersistedModalName.TermsComponent, ModalType.View));
      });
  }
}
